import { deserialize } from 'cerialize'

export class DrsFakeResponsesReserveModel {
	@deserialize public id: number
	@deserialize public inn: string
	@deserialize public code: number
	@deserialize public body: string
	@deserialize public stage: string
	@deserialize public is_active: boolean
	@deserialize public success: boolean
}
